import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServerService } from 'src/app/core/service/server.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  
  isLoading: Subject<boolean> = this.serverService.isLoading;

  constructor(private spinner: NgxSpinnerService, private serverService:ServerService) { }

  ngOnInit() {
    this.isLoading.subscribe(
      (value) => {
        setTimeout(() => {
          if(value)
            this.spinner.show();
          else
            this.spinner.hide();
        }, 150)
      }
    )
  } 

}
